module.exports = __webpack_public_path__ + "img/user-config-back.2d2fc3b3.png";